var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4473 9C15.055 8.99993 10.5392 13.0845 10 18.4498H17.2974V16.8749C17.2974 16.5849 17.5324 16.3499 17.8224 16.3499H23.0723C23.3622 16.3499 23.5973 16.5849 23.5973 16.8749V22.1248C23.5973 22.4147 23.3622 22.6498 23.0723 22.6498H17.8224C17.5324 22.6498 17.2974 22.4147 17.2974 22.1248V20.5498H10C10.5662 26.1838 15.498 30.3541 21.1478 29.9762C26.7976 29.5984 31.1301 24.8087 30.9412 19.1494C30.7522 13.4901 26.1097 9.00007 20.4473 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer8);
export default __webpack_public_path__ + "static/media/offer_8.3fb6ada2610242c751784684d4e5297f.svg";
export { ForwardRef as ReactComponent };